module.exports = __webpack_public_path__ + "img/ico_jg1.bc1183d8.png";